import { Component, AfterViewInit, SimpleChanges, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { gb } from '../../../growthbook';

// The global _flutter namespace
declare var _flutter: any;
declare var window: {
  _debug: any
};

@Component({
  selector: 'ng-flutter',
  template: `
    <div #flutterTarget class="flutter-app"></div>
  `,
  styles: [`
    .flutter-app {
      width: 56vh; height: 88vh;
    }
  `],
})
export class NgFlutterComponent implements AfterViewInit {
  @ViewChild('flutterTarget') flutterTarget: ElementRef;

  @Input() srcBase: string = "/assets/flutter_modernization/web/main.dart.js";
  @Input() assetBase: string = '/flutter/';
  @Output() appLoaded: EventEmitter<object> = new EventEmitter<object>();


  get src(): string {
    let serviceWorkerVersion = gb.getFeatureValue("flutter-service-worker-version");
    return `${this.srcBase}?v=${serviceWorkerVersion}`;
  }

  async ngAfterViewInit(): Promise<void> {
    const target: HTMLElement = this.flutterTarget.nativeElement;

    await _flutter.loader.loadEntrypoint({
      entrypointUrl: this.src,
      onEntrypointLoaded: async (engineInitializer: any) => {
        let appRunner = await engineInitializer.initializeEngine({
          hostElement: target,
          assetBase: this.assetBase,
        });
        console.log(appRunner);
        await appRunner.runApp();
      }
    });
    target.addEventListener("flutter-initialized", (event: Event) => {
      let state = (event as CustomEvent).detail;
      window._debug = state;
      this.appLoaded.emit(state);
    }, false);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/flutter/flutter-wrapper.component.ts